import styled from 'styled-components';

export const StyledHospitalCard = styled.div`
    ${({ theme }) => `
    height: 100%;
    width: 100%;
    padding: 10px 10px 10px 20px;

    background: linear-gradient(244.44deg, rgba(255, 255, 255, 0.9) 9.8%, rgba(255, 255, 255, 0.6) 77.52%);
    border-radius: 16px;
    border: 1px solid ${theme.palette.common.white};
    box-shadow: 0px 4px 8px rgba(204, 208, 227, 0.3);

    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    column-gap: 15px;
    `}
`;
